<template>
  <aside class="sign-in-button-group">
    <div class="sign-in-button-cell post-sign-in">
      <button class="post-sign-in__button button"
              :class="signinButtonClasses"
              :disabled="signinButtonDisabled"
              @click="onSubmitSignin()">
        {{ signinSubmitButtonText }}
      </button>
      <button class="post-sign-in__button button"
              v-if="enableSignout"
              :class="signoutButtonClasses"
              :disabled="signoutButtonDisabled"
              @click="onSubmitSignout()">
        {{ signoutSubmitButtonText }}
      </button>
      <button class="post-sign-in__button button"
              v-if="hasSignIn"
              :class="cancelButtonClasses"
              @click="onCancelSignIn()">
        撤销签到
      </button>
    </div>
    <draw-signature-modal
      :visible="showSignatureModal"
      @confirm="handleSignatureConfirm"
      @cancel="handleSignatureCancel"
    />
  </aside>
</template>
<style lang="stylus" scoped>
@import '../../styles/index.styl'
.sign-in-button-group
  // width: 14rem
  display inline-block
.sign-in-button-cell
  display inline-block
.cancel-sign-in
  color info-blue
  text-decoration underline
  font-size 1rem
// .post-sign-in
//   padding-left 1rem
.post-sign-in__button
  vertical-align baseline
  height: 1.6rem
  line-height 1.4rem
  padding-left: 5px
  padding-right: 5px
</style>
<script>
import * as aTypes from '../../../store/action-types'
import DrawSignatureModal from './DrawSignatureModal.vue'
import QiniuUploader from '../../../utils/qiniuUploader'
export default {
  components: {
    DrawSignatureModal
  },
  props: {
    activitySessionTime: Object,
    signUpId: String,
    number: String,
    loading: Boolean,
    activityConfig: Object
  },
  data () {
    return {
      signInDisabled: false,
      cancelSignInDisabled: false,
      showSignatureModal: false,
      pendingSignatureFileId: null
    }
  },
  computed: {
    hasSignIn () {
      return Boolean(this.signIn)
    },
    isLoading () {
      return this.signinLoading || this.signoutLoading || this.cancelSigninLoading
    },
    signIn () {
      return this.activitySessionTime.sign_in
    },
    needDrawSignature () {
      return this.activityConfig && this.activityConfig.activity_signed_in_draw_signature === '1'
    },
    qiniuConfig () {
      return this.$store.state.qiniuConfig || {}
    },
    signinSubmitButtonText () {
      return this.hasSignIn ? '已签到' : '签到'
    },
    signinButtonClasses () {
      return {
        'is-outlined': this.hasSignIn,
        'disabled': this.hasSignIn,
        'is-rounded': !this.hasSignIn,
        'is-info': !this.hasSignIn,
        'is-loading': this.isLoading
      }
    },
    signinButtonDisabled () {
      return this.hasSignIn
    },
    signinLoading () {
      return this.$store.state.loading[aTypes.ACTIVITY_POST_SIGNIN]
    },

    canSignout () {
      return this.activitySessionTime.sign_in.can_signout
    },
    enableSignout () {
      return this.activitySessionTime.sign_in.enable_signout
    },
    signoutSubmitButtonText () {
      return this.canSignout ? '签退' : '已签退'
    },
    signoutButtonClasses () {
      return {
        'is-outlined': !this.canSignout,
        'disabled': !this.canSignout,
        'is-rounded': this.canSignout,
        'is-info': this.canSignout,
        'is-loading': this.isLoading
      }
    },
    cancelButtonClasses () {
      return {
        'is-info': true,
        'is-loading': this.isLoading
      }
    },
    signoutLoading () {
      return this.$store.state.loading[aTypes.ACTIVITY_POST_SIGNOUT]
    },
    signoutButtonDisabled () {
      return !this.canSignout
    },
    cancelSigninLoading () {
      return this.$store.state.loading[aTypes.ACTIVITY_POST_CANCEL_SIGNIN]
    }
  },
  methods: {
    onSubmitSignin () {
      if (this.hasSignIn) {
        return
      }
      if (this.disableSubmit) {
        return
      }
      // 判断是否需要手写签名
      if (this.needDrawSignature) {
        this.showSignatureModal = true
      } else {
        this.doSignIn()
      }
    },
    doSignIn (signatureFileId = null) {
      this.$emit('submit-sign-in', this.activitySessionTime.id, this.signUpId, this.number, signatureFileId)
    },
    async handleSignatureConfirm (dataURL) {
      try {
        this.showSignatureModal = false
        // 显示loading状态
        this.$store.commit('SET_LOADING', { key: 'uploadingSignature', loading: true })
        // 转换为文件
        const uploader = new QiniuUploader(this.qiniuConfig)
        const fileName = `signature_${Date.now()}_${QiniuUploader.randomString(10)}.png`
        const file = uploader.base64ToFile(dataURL, fileName)
        // 上传到七牛
        const response = await uploader.uploadFile(file, {
          objectType: 'activity',
          subObjectId: this.signUpId
        })
        if (response && response.data && response.data.id) {
          // 获取文件ID后执行签到
          this.doSignIn(response.data.id)
        } else {
          throw new Error('上传返回数据格式错误')
        }
      } catch (error) {
        console.error('签名上传失败:', error)
        alert('签名上传失败，请重试')
      } finally {
        this.$store.commit('SET_LOADING', { key: 'uploadingSignature', loading: false })
      }
    },
    handleSignatureCancel () {
      this.showSignatureModal = false
    },
    onSubmitSignout () {
      if (this.enableSignout && this.canSignout) {
        this.$emit('submit-sign-out', this.activitySessionTime.id, this.signUpId, this.number)
      }
    },
    onCancelSignIn () {
      if (this.disableSubmit) {
        return
      }
      this.$emit('cancel-sign-in', this.signIn.id, this.signUpId, this.number)
    }
  }
}
</script>



// WEBPACK FOOTER //
// SignInButton.vue?6feae536